import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, LoadingController } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
import { HomePage } from '../pages/home/home';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

@Component({
  templateUrl: 'app.html'
})

export class MyApp {

  @ViewChild(Nav) nav: Nav;

  loader: any;
  rootPage: any = HomePage;    
  pages: Array<{title: string, iconname: string, optioncolor: string, component: any}>;
  
  constructor(public splashScreen: SplashScreen, platform: Platform, 
              public loadingCtrl: LoadingController, 
              public storage: Storage,
              private ga: GoogleAnalytics) {

   //Google Analytics
   this.ga.startTrackerWithId('UA-2680400-1')
   .then(() => {
     console.log('Google analytics is ready now');
        this.ga.trackView('test');
     // Tracker is ready
     // You can now track pages or set additional information such as AppVersion or UserId
   })
   .catch(e => console.log('Error starting GoogleAnalytics', e));

   this.storage.set('introShown', true); //FALSE UNTIL WE KNOW WTHERE TO USE IT. THEN REMOVE WHEN LIVE
   this.pages = [
      { title: 'Experience Us', iconname: 'bonfire' , optioncolor: 'darker', component: 'ExperienceUs' },
      { title: 'Our Wildlife', iconname: 'paw' , optioncolor: 'darker', component: 'OurWildlife' },
      { title: 'About Us', iconname: 'information-circle' , optioncolor: 'darker', component: 'AboutUs' },
      { title: 'Join Us', iconname: 'contacts' , optioncolor: 'darker', component: 'JoinUs' },
      { title: 'Contact Us', iconname: 'chatbubbles' , optioncolor: 'lighter', component: 'ContactUs' },
    ]; 
       
    this.presentLoading();
   
    platform.ready().then(() => {
        this.splashScreen.hide();
        this.loader.dismiss();
       
       /*
      this.storage.get('introShown').then((result) => {
        if(result){
          this.rootPage = HomePage;
        } else {
          this.rootPage = 'Intro'; 
          this.storage.set('introShown', true); //NEEDS TO BE TRUE FOR LIVE
        }
       });   
       */
        
    });

  }
  

  presentLoading() { 
    this.loader = this.loadingCtrl.create({
      content: "Loading up, won't be long :-)"
    }); 
   this.loader.present(); 
  }

  
    
  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);      
   
    switch (page.title) {
    case "Experience Us":
    case "Safari Holidays":
    case "Day Safaris":
    case "Acivities":
     // confirm("We are going to use the " +page.title+ " menu.");
      this.pages = [
      { title: 'Safari Holidays', iconname: 'bonfire' , optioncolor: 'darker', component: 'SafariHolidays' },
      { title: 'Day Safaris', iconname: 'paw' , optioncolor: 'darker', component: 'Daysafaris' },
      { title: 'Acivities', iconname: 'attach' , optioncolor: 'darker', component: 'Activities' },      
      { title: 'Home', iconname: 'home' , optioncolor: 'lighter', component: HomePage },
      { title: 'Experience Us', iconname: 'bonfire' , optioncolor: 'lighter', component: 'ExperienceUs' },
      { title: 'About Us', iconname: 'information-circle' , optioncolor: 'lighter', component: 'AboutUs' },
      { title: 'Our Wildlife', iconname: 'paw' , optioncolor: 'lighter', component: 'OurWildlife' },
      { title: 'Join Us', iconname: 'contacts' , optioncolor: 'lighter', component: 'JoinUs' },
      { title: 'Contact Us', iconname: 'chatbubbles' , optioncolor: 'lighter', component: 'ContactUs' }
    ];
    break;
    case "About Us":
    case "Location":
    case "Nearby Attractions":
    case "History":
     // confirm("We are going to use the " +page.title+ " menu." );
      this.pages = [
      { title: 'Location', iconname: 'locate' , optioncolor: 'darker', component: 'Location' },
      { title: 'Nearby Attractions', iconname: 'camera' , optioncolor: 'darker', component: 'Nearby' },
      { title: 'History', iconname: 'clock' , optioncolor: 'darker', component: 'History' },      
      { title: 'Home', iconname: 'home' , optioncolor: 'lighter', component: HomePage },
      { title: 'Experience Us', iconname: 'bonfire' , optioncolor: 'lighter', component: 'ExperienceUs' },
      { title: 'About Us', iconname: 'information-circle' , optioncolor: 'lighter', component: 'AboutUs' },
      { title: 'Our Wildlife', iconname: 'paw' , optioncolor: 'lighter', component: 'OurWildlife' },
      { title: 'Join Us', iconname: 'contacts' , optioncolor: 'lighter', component: 'JoinUs' },
      { title: 'Contact Us', iconname: 'chatbubbles' , optioncolor: 'lighter', component: 'ContactUs' }
    ];
      break;
    case "Join Us":
    case "Field Guides":
    case "Volunteers":
    case "Owners":
     // confirm("We are going to use the " +page.title+ " menu.");
      this.pages = [
      { title: 'Field Guides', iconname: 'compass' , optioncolor: 'darker', component: 'Fieldguides' },
      { title: 'Volunteers', iconname: 'clipboard' , optioncolor: 'darker', component: 'Volunteers' },
      { title: 'Owners', iconname: 'key' , optioncolor: 'darker', component: 'Owner' },
      { title: 'Home', iconname: 'home' , optioncolor: 'lighter', component: HomePage },
      { title: 'About Us', iconname: 'information-circle' , optioncolor: 'lighter', component: 'AboutUs' },
      { title: 'Experience Us', iconname: 'bonfire' , optioncolor: 'lighter', component: 'ExperienceUs' },
      { title: 'Our Wildlife', iconname: 'paw' , optioncolor: 'lighter', component: 'OurWildlife' },
      { title: 'Join Us', iconname: 'contacts' , optioncolor: 'lighter', component: 'JoinUs' },
      { title: 'Contact Us', iconname: 'chatbubbles' , optioncolor: 'lighter', component: 'ContactUs' }
    ];
    break;
    case "Our Wildlife":
    case "Conservation":
    case "Wildlife":
    case "Gallery":
    //  confirm("We are going to use the " +page.title+ " menu.");
      this.pages = [
      { title: 'Wildlife', iconname: 'paw' , optioncolor: 'darker', component: 'Wildlife' },
      { title: 'Conservation', iconname: 'alarm' , optioncolor: 'darker', component: 'Conservation' },
      { title: 'Gallery', iconname: 'images' , optioncolor: 'darker', component: 'Gallery' },
      { title: 'Home', iconname: 'home' , optioncolor: 'lighter', component: HomePage },
      { title: 'About Us', iconname: 'information-circle' , optioncolor: 'lighter', component: 'AboutUs' },
      { title: 'Our Wildlife', iconname: 'paw' , optioncolor: 'lighter', component: 'OurWildlife' },
      { title: 'Experience Us', iconname: 'bonfire' , optioncolor: 'lighter', component: 'ExperienceUs' },
      { title: 'Join Us', iconname: 'contacts' , optioncolor: 'lighter', component: 'JoinUs' },
      { title: 'Contact Us', iconname: 'chatbubbles' , optioncolor: 'lighter', component: 'ContactUs' }
    ];
    break;
    default:
    //  confirm("Sorry no valid page selected, going to the default menu!");
      this.pages = [
      { title: 'Home', iconname: 'home' , optioncolor: 'lighter', component: HomePage },
      { title: 'Experience Us', iconname: 'bonfire' , optioncolor: 'lighter', component: 'ExperienceUs' },
      { title: 'Our Wildlife', iconname: 'paw' , optioncolor: 'lighter', component: 'OurWildlife' },
      { title: 'About Us', iconname: 'information-circle' , optioncolor: 'lighter', component: 'AboutUs' },
      { title: 'Join Us', iconname: 'contacts' , optioncolor: 'lighter', component: 'JoinUs' },
      { title: 'Contact Us', iconname: 'chatbubbles' , optioncolor: 'lighter', component: 'ContactUs' }
    ];
    }    
  
  }
}
 


// WEBPACK FOOTER //
// ./src/app/app.component.ts